"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiImpacteesParCorporation = void 0;
exports.ESubScpiImpacteesParCorporation = {
    evolutionLoyer: "evolutionLoyer",
    evolutionMarcheImmo: "evolutionMarcheImmo",
    desDeux: "desDeux",
};
